import { render, staticRenderFns } from "./SubmitBar.vue?vue&type=template&id=15597510&"
import script from "./SubmitBar.vue?vue&type=script&lang=js&"
export * from "./SubmitBar.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15597510')) {
      api.createRecord('15597510', component.options)
    } else {
      api.reload('15597510', component.options)
    }
    module.hot.accept("./SubmitBar.vue?vue&type=template&id=15597510&", function () {
      api.rerender('15597510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/SubmitBar.vue"
export default component.exports